export const LC_SELECTED_PUBLISHER_KEY = '_selectedPublisher';

export const LC_ONBOARDING_FINISHED = '_onboardingFinished';
